import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UiWrapperComponent } from './ui-wrapper/ui-wrapper.component';


const routes: Routes = [
  {
    path: '',
    component: UiWrapperComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        loadChildren: () => import(`../pages/homepage/homepage.module`)
          .then(m => m.HomepageModule),
        canActivateChild: [],
      },
      {
        path: 'workspaces',
        loadChildren: () => import(`../pages/workspaces/workspaces.module`)
          .then(m => m.WorkspacesModule),
        canActivateChild: [],
      },
      {
        path: 'project',
        loadChildren: () => import(`../pages/single-project/single-project.module`)
          .then(m => m.SingleProjectModule),
        canActivateChild: [],
      },
      {
        path: 'directory',
        loadChildren: () => import(`../pages/directory/directory.module`)
          .then(m => m.DirectoryModule),
        canActivateChild: [],
      },
      {
        path: 'profile',
        loadChildren: () => import(`../pages/profile/profile.module`)
          .then(m => m.ProfileModule),
        canActivateChild: [],
      },
      {
        path: 'collaborators',
        loadChildren: () => import(`../pages/collaborators/collaborators.module`)
          .then(m => m.CollaboratorsModule),
        canActivateChild: [],
      },
      {
        path: 'trash',
        loadChildren: () => import(`../pages/trash/trash.module`)
          .then(m => m.TrashModule),
        canActivateChild: [],
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class UiComponentsRoutingModule { }
